export var IdStyles;
(function (IdStyles) {
    // Empty
    IdStyles["Empty"] = "";
    // Placeholder Icons
    IdStyles["IconPlaceholderSmall"] = "icon-placeholder__small";
    IdStyles["IconPlaceholderMedium"] = "icon-placeholder__medium";
    IdStyles["IconPlaceholderLarge"] = "icon-placeholder__large";
    IdStyles["IconPlaceholderExtraLarge"] = "icon-placeholder__extra-large";
    // Icons
    IdStyles["IconSmall"] = "sprite-icons-ui-s icons-ui-s-";
    IdStyles["IconMedium"] = "sprite-icons-ui-m icons-ui-m-";
    IdStyles["IconLarge"] = "sprite-icons-ui-l icons-ui-l-";
    IdStyles["IconExtraLarge"] = "sprite-icons-ui-xl icons-ui-xl-";
    // States
    IdStyles["StateSelected"] = "selected";
    IdStyles["StateLocked"] = "locked";
    IdStyles["StateCompleted"] = "state-completed";
    IdStyles["StateHover"] = "hover";
    // Modal
    IdStyles["ModalBackground"] = "modal-background";
    IdStyles["ModalHeader"] = "modal-header";
    IdStyles["ModalFooter"] = "modal-footer";
    IdStyles["ModalButtonClose"] = "modal-button-close";
    // CSS buttons
    // Primary
    IdStyles["ButtonPrimary"] = "greenBtn";
    IdStyles["ButtonPrimaryAccent"] = "blueBtn";
    // Secondary
    IdStyles["ButtonSecondary"] = "beigeBtn";
    IdStyles["ButtonSecondaryAccent"] = "brownBtn";
    // Custom
    IdStyles["ButtonHighlight"] = "yellowBtn";
    IdStyles["ButtonSpecial"] = "pinkBtn";
    IdStyles["ButtonImportant"] = "redBtn";
    IdStyles["ButtonInformation"] = "facebookBtn";
    // Divider
    IdStyles["ButtonDivider"] = "button-divider";
    // Disabled
    IdStyles["ButtonDisabled"] = "disabledBtn";
    // SVG buttons
    IdStyles["DefaultRoundBtn"] = "DefaultRoundBtn";
    IdStyles["ButtonSort"] = "SortBtnN";
    IdStyles["ScrollArrowRight"] = "ScrollArrowRightBtn";
    IdStyles["ScrollArrowLeft"] = "ScrollArrowLeftBtn";
    IdStyles["FloatingButtonBackground"] = "floating-button-background";
    IdStyles["HeadlineOne"] = "headline-primary";
    IdStyles["HeadlineAccent"] = "headline-primary-accent";
    IdStyles["TextAlignCenter"] = "text-align-center";
    IdStyles["ImageBoxContainer"] = "image-box-container";
    IdStyles["ImageBoxContainerSmall"] = "image-box-container--smalll";
    IdStyles["ImageBoxContainerPremiumSmall"] = "image-box-premium-container--smalll";
    IdStyles["ImageBoxContainerPremiumSpecialSmall"] = "image-box-premium-purple-container--small";
    IdStyles["TabItemBackground"] = "tab-background";
    // Character Styles
    IdStyles["TextButtonHeading"] = "button-text__heading";
    IdStyles["TextButtonDefault"] = "button-text-default";
    IdStyles["TextNormal"] = "text-normal";
    IdStyles["TextSmall"] = "text-small";
    IdStyles["TextVerySmall"] = "text-very-small";
    IdStyles["TextSmallSecondary"] = "text-small__white";
    IdStyles["TextBoldPrimary"] = "text-bold";
    IdStyles["TextBoldAccent"] = "text-bold-accent";
    IdStyles["TextPositive"] = "text-positive";
    IdStyles["TextNegative"] = "text-negative";
    IdStyles["TextBoldSecondaryOutline"] = "text-bold__white__stroke";
    IdStyles["TextSmallBoldSecondaryOutline"] = "text-bold__white__stroke__small";
    IdStyles["TextBoldSecondary"] = "text-bold__white";
    IdStyles["TextLink"] = "text-normal__link";
    IdStyles["TextLinkSmall"] = "text-small__link";
    IdStyles["TextError"] = "text-error";
    IdStyles["StatBackground"] = "stat-background";
    IdStyles["DetailViewWrapper"] = "content-default-wrapper";
    IdStyles["DetailView"] = "content-default";
    IdStyles["TableRow"] = "table-row";
    IdStyles["ImagePlaceholder"] = "image-placeholder";
    // Building Upgrade Dialog
    IdStyles["BuildingUpgradeRequirementWrapper"] = "building-upgrade-container-requirement";
    IdStyles["BuildingUpgradeEffectsWrapper"] = "building-upgrade-container-upgrade";
    IdStyles["BuildingUpgradeRequirementDisabled"] = "building-upgrade-container-not-available";
    IdStyles["ModalBackgroundBuildingUpgrade"] = "modal-background-building-upgrade";
    // Quest Menu
    IdStyles["QuestDescriptionBackground"] = "balloon-description";
    IdStyles["QuestRewardsBackground"] = "quest-rewards-background";
    IdStyles["QuestRewardsBackgroundCompleted"] = "rewards";
    IdStyles["QuestTaskBackground"] = "balloon-task";
    IdStyles["QuestTaskFinishedBackground"] = "balloon-task-finished";
    // Quest Panel
    IdStyles["QuestPanel"] = "quest-panel";
    IdStyles["GreenScrollButton"] = "GreenScrollBtn";
    IdStyles["QuestPanelDivider"] = "quest-divider-dark";
    // Quick Sell
    IdStyles["QuickSellContainerStorage"] = "quick-sell-container-storage";
    IdStyles["QuickSellContainerTip"] = "quick-sell-container-tip";
    IdStyles["ModalBackgroundQuickSell"] = "modal-background-quick-sell";
    IdStyles["QuickSellContainerSell"] = "quick-sell-container-sell";
    IdStyles["QuickSellStatContainer"] = "quick-sell-stat-container";
    // Progress Bar
    IdStyles["ProgressBarFill"] = "progress-bar-fill";
    IdStyles["ProgressBarBackground"] = "progress-bar-background";
    IdStyles["ProgressBarIncompleteFill"] = "progress-bar-fill-medium-yellow";
    IdStyles["ProgressBarIncompleteBackground"] = "progress-bar-background-medium";
    // Buy Gold
    IdStyles["ModalBackgroundBuyGold"] = "modal-background-buy-gold";
    // Build Menu
    IdStyles["BuildMenuRequirementSection"] = "build-menu-section-background";
    IdStyles["BuildMenuRequirementWrapper"] = "build-menu-container-requirement";
    IdStyles["BuildMenuGridItem"] = "item-default";
    IdStyles["BuildMenuGridItemSpecial"] = "item-premium";
    IdStyles["BuildMenuGridItemWrapper"] = "item-default-wrapper";
    // Info Menu
    IdStyles["InfoMenuTitleContainer"] = "info-container-title";
    IdStyles["InfoMenuListContainer"] = "info-container-list";
    IdStyles["Divider"] = "divider";
    IdStyles["Light"] = "light";
    IdStyles["Dark"] = "dark";
    IdStyles["ModalBackgroundInfo"] = "modal-background-info";
    // Context Menu
    IdStyles["ContextMenuRunningProductionBuildingWrapper"] = "context-menu-content-default-wrapper-small";
    IdStyles["ContextMenuRunningProductionBuilding"] = "context-menu-content-default-small";
    IdStyles["ContextMenuProductionBuilding"] = "context-menu-content-default-large";
    IdStyles["ContextMenuBalloon"] = "context-menu-content-default-details";
    IdStyles["RecipeItem"] = "resource";
    IdStyles["ContextMenuBackground"] = "context-menu-output-background";
    // Market Menu
    IdStyles["MarketGridItemContract"] = "note";
    IdStyles["MarketGridItemContractNotAvailable"] = "note-background";
    IdStyles["MarketGridItemContractShowMeLabel"] = "note-label-background";
    IdStyles["MarketMenuMasterViewBackground"] = "market-menu-section-background";
    IdStyles["MarketMenuRequirementsBackground"] = "market-products-container-background";
    IdStyles["MarketMenuRewardsBackground"] = "market-rewards-container-background";
    // Buy Expansion
    IdStyles["ModalBackgroundBuyExpansion"] = "modal-background-buy-expansion";
    IdStyles["BuyExpansionStandardBackground"] = "buy-expansion-background-light";
    IdStyles["BuyExpansionPremiumBackground"] = "buy-expansion-background";
    IdStyles["BuyExpansionRequirementContainer"] = "buy-expansion-resource-container";
    IdStyles["BuyExpansionDisabled"] = "expansion-container-not-available";
    // Level Up
    IdStyles["ModalBackgroundLevelUp"] = "modal-background-level-up";
    IdStyles["LevelUpDialogRewardsWrapper"] = "level-up-container-wrapper";
    IdStyles["LevelUpDialogRewards"] = "level-up-container";
    // Farm Management
    IdStyles["FarmManagementTabBackground"] = "dialog-requirement-container";
    IdStyles["FarmManagementTabHeaderBackground"] = "tabs-content-background";
    // Trade Resource
    IdStyles["InventoryBuyContainerCost"] = "inventory-buy-container-costs";
    // Slider
    IdStyles["SliderTrackHorizontalBackground"] = "slider-amount-background";
    IdStyles["SliderFillHorizontal"] = "slider-amount-fill";
    IdStyles["SliderThumbHorizontal"] = "SliderBtn";
    // Grid Item
    IdStyles["GridItemContainerPremiumSpecial"] = "item-premium-purple";
    // HUD
    IdStyles["HudStat"] = "hud-stat";
    IdStyles["HudFooterBackground"] = "HUD-footer";
    IdStyles["HudDivider"] = "HUD-divider";
    // Callout
    IdStyles["CalloutIdle"] = "call-out-blue";
    IdStyles["CalloutComplete"] = "call-out-yellow";
    IdStyles["CalloutNeutral"] = "call-out-white";
    // Not Enough Resources
    IdStyles["ModalBackgroundResources"] = "modal-background-resources";
    IdStyles["IconAmount"] = "icon-amount";
    IdStyles["IconAmountContainer"] = "icon-amount-container";
    // Reward
    IdStyles["RewardDialogContentContainer"] = "reward-container-rewards";
    IdStyles["RewardDialogRewardsContainer"] = "reward-container-description";
    IdStyles["RewardDialogRewardsWrapper"] = "level-up-container-wrapper";
    IdStyles["RewardDialogRewards"] = "level-up-container";
    IdStyles["RewardDialogCharacterPlaceholder"] = "character-placeholder";
    // Tutorial
    IdStyles["TutorialBalloon"] = "tutorial-balloon";
    IdStyles["TutorialCharacterPlaceholder"] = "character-placeholder";
    // Loading
    IdStyles["LoadingBarBackground"] = "loading-bar-background";
    IdStyles["LoadingBarFillDefault"] = "init-loading-bar-fill-default";
    IdStyles["LoadingBarFillWinter"] = "init-loading-bar-fill-winter";
    IdStyles["LoadingLogo"] = "loading-logo";
    // CharacterHelp
    IdStyles["CharacterHelpDescriptionBackground"] = "balloon-description";
    // Shop
    IdStyles["OfferBadge"] = "offer-badge";
    IdStyles["OfferBanner"] = "offer-image";
    IdStyles["OfferHeader"] = "offer-slideshow-header";
    IdStyles["OfferBackground"] = "offer-background";
    IdStyles["OfferSlideshowBackground"] = "offer-slideshow-background";
    IdStyles["OfferBonusGreenBackground"] = "offer-bonus-green-background";
    IdStyles["OfferBonusLarge"] = "bonus-container-large";
    IdStyles["OfferDetailsHeader"] = "offers-package-header-background";
    IdStyles["OfferShittyPackageHeader"] = "offers-shitty-package-header-background";
    IdStyles["OfferLevelRewardContainer"] = "offer-growth-fund-cost-container";
    IdStyles["OfferLevelRewardListBackground"] = "growth-fund-wood-image";
    IdStyles["OfferLevelRewardListItem"] = "list-entry-large-offer";
    IdStyles["OfferRewardListItem"] = "list-entry-default";
    IdStyles["OfferPurchaseRewardListItem"] = "offer-reward-list-entry-default";
    IdStyles["OfferRewardListBackground"] = "offer-wood-placeholder";
    IdStyles["OfferPurchaseRewardHeaderBackground"] = "offer-reward-package-header-background";
    IdStyles["OfferPurchaseRewardBackground"] = "offer-purchase-reward-background";
    IdStyles["OfferPageIndicator"] = "DotInactiveShopGfx";
    IdStyles["OfferPageIndicatorSelected"] = "DotActiveShopGfx";
    IdStyles["PurchasePointsBig"] = "purchase-points-big";
    IdStyles["ShopPaymentProviderItem"] = "payment-method-default";
    IdStyles["ShopPurchaseOfferBackground"] = "offer-rewards";
    IdStyles["ShopSupportButton"] = "support-btn";
    IdStyles["SmsContainer"] = "sms-panel-sms-background";
    IdStyles["SmsPackageContainer"] = "sms-offer-package-background";
    IdStyles["SmsContainerSeparator"] = "tab-panel-sms-separator";
    IdStyles["SmsTab"] = "tab-panel-sms";
    IdStyles["SmsTabBackground"] = "tab-background-panel-sms";
    IdStyles["BackToOffersButton"] = "back-to-offers-btn";
    // Quest Intros
    IdStyles["QuestIntroBalloon"] = "balloon";
    // Dog House
    IdStyles["DogTreatRewardWonContainer"] = "dog-treat-reward-won-container";
    IdStyles["DogTreatRewardsContainer"] = "dog-treat-rewards-container";
    IdStyles["DogGraphicRewardContainer"] = "dog-graphic-reward__container";
    IdStyles["DogGraphicContainer"] = "dog-graphic";
    IdStyles["RewardListEntryMid"] = "list-entry-mid";
    // Promote mobile
    IdStyles["MobilePromoBackground"] = "Mobile-Promo-background";
    // Ranking menu
    IdStyles["TableRowRankingBig"] = "table-row-ranking-big";
    IdStyles["TableRowRankingBigSelected"] = "table-row-ranking-big-selected";
    IdStyles["TableRowRankingBigGold"] = "table-row-ranking-big-gold";
    IdStyles["TableRowRankingBigSilver"] = "table-row-ranking-big-silver";
    IdStyles["TableRowRankingBigBronze"] = "table-row-ranking-big-bronze";
    IdStyles["CoopSearchContainer"] = "coop-search-container";
    IdStyles["CoopSearchNameInput"] = "coop-search-name-input";
    IdStyles["CooperativeLevelUpText"] = "Cooperative-level-up-text";
    IdStyles["RankingListContainer"] = "ranking-list-container";
    IdStyles["ModalBackgroundLanguageSelection"] = "modal-background-language-selection";
    IdStyles["LanguageSelectionBackground"] = "language-selection-background";
    // profile pictures
    IdStyles["ProfilePictureSmall"] = "sprite-profiles-small profiles-small";
    IdStyles["ProfilePictureX_small"] = "sprite-profiles-x_small profiles-x_small";
    IdStyles["ProfilePictureLarge"] = "sprite-profiles-large profiles-large";
    // Wrapper for selection
    IdStyles["ProfilePictureWrapper"] = "profile-item-default-wrapper";
    IdStyles["ProfilePictureContainer"] = "profile-item-default";
    IdStyles["ProfilePictureBalloon"] = "profile-picture-balloon";
    // facebook dialog
    IdStyles["AnotherSavePrimaryContainer"] = "another-save-primary-container";
    IdStyles["AnotherSaveSecondaryContainer"] = "another-save-secondary-container";
    IdStyles["AnotherSaveCurrencyContainer"] = "another-save-currency-container";
    IdStyles["AnotherSaveDialogVMargin"] = "another-save-dialog-v-margin";
    IdStyles["TextWrapBreakWord"] = "text-wrap-break-word";
    // Tournament
    IdStyles["TableRowRanking"] = "table-row-ranking";
    IdStyles["TeaserDescriptionContainerLarge"] = "teaser-container-description-large";
    IdStyles["TeaserCharacterLevelLeft"] = "teaser-level-low-character-left";
    IdStyles["TournamentTopPrizes"] = "tournament-rewards-container";
    IdStyles["TournamentDetailsContainer"] = "tournament-balloon-container";
    IdStyles["TournamentThresholdContainer"] = "tournament-tresholds-container";
    IdStyles["TournamentThresholdSelectedContainer"] = "tournament-treshold-content-default";
    IdStyles["TournamentThresholdSelectedContainerWrapper"] = "tournament-treshold-content-default-wrapper";
    IdStyles["TournamentThresholdProgressBarBackground"] = "progress-bar-background-large";
    IdStyles["TournamentThresholdProgressBarFill"] = "progress-bar-fill-large-green";
    IdStyles["LeaguesContainer"] = "leagues-container";
    IdStyles["LeagueRewardContainer"] = "league-reward-container";
    IdStyles["ModalBackgroundLeagueReward"] = "modal-background-league-reward";
    IdStyles["LeagueButtonContainer"] = "league-button-container";
    IdStyles["LeagueContentDefault"] = "league-content-default";
    IdStyles["LeagueContentBronze"] = "league-content-bronze";
    IdStyles["LeagueContentBronzeSelected"] = "league-content-bronze-selected";
    IdStyles["LeagueContentSilver"] = "league-content-silver";
    IdStyles["LeagueContentSilverSelected"] = "league-content-silver-selected";
    IdStyles["LeagueContentGold"] = "league-content-gold";
    IdStyles["LeagueContentGoldSelected"] = "league-content-gold-selected";
    IdStyles["LeagueContentEmerald"] = "league-content-emerald";
    IdStyles["LeagueContentEmeraldSelected"] = "league-content-emerald-selected";
    IdStyles["LeagueContentSapphire"] = "league-content-sapphire";
    IdStyles["LeagueContentSapphireSelected"] = "league-content-sapphire-selected";
    IdStyles["LeagueMedalContainer"] = "league-medal-container";
    IdStyles["IconAmountContainerReward"] = "icon-amount-container-reward";
    IdStyles["TournamentGroupRankingContainer"] = "tournament-group-ranking-container";
    IdStyles["TableHeaderGold"] = "table-header-gold";
    IdStyles["TableHeaderSilver"] = "table-header-silver";
    IdStyles["TableHeaderBronze"] = "table-header-bronze";
    IdStyles["TableHeaderDefault"] = "table-header-default";
    IdStyles["LeaguesPromotionBaloon"] = "leagues-promotion-balloon";
    IdStyles["CollectEventRewardsDescription"] = "collecting-event-reward-description";
    // Water Tower
    IdStyles["WaterCollectContainer"] = "water-collect-container";
    IdStyles["WaterAmountContainer"] = "water-amount-container";
    IdStyles["WaterTowerPlaceholder"] = "water-tower-placeholder";
    // Library
    IdStyles["LibraryBook"] = "library-book";
    IdStyles["LibraryBookTextBackground"] = "library-book-background";
    // Improvement
    IdStyles["ImprovementCurrentBonusBackground"] = "library-bonus-background";
    IdStyles["ImprovementNextBonusBackground"] = "library-next-bonus-background";
    IdStyles["ImprovementRequirementsContainerBackground"] = "library-requirements-background";
    IdStyles["ImprovementMaxLevelReachedContainer"] = "library-bonus-container-background";
    // themed event
    IdStyles["DifficultyBackground"] = "difficulty-background";
    IdStyles["DifficultyBackgroundSelected"] = "choose-difficulty-background-selected";
    IdStyles["BuildingIconBackground"] = "building-icon-background";
    IdStyles["BuildingIconBackgroundSelected"] = "building-icon-background-selected";
    IdStyles["HappinessContainer"] = "happiness-container";
    IdStyles["SelectedDifficultyTickBackground"] = "selected-difficulty-tick-background";
    IdStyles["ThemedEventBalloonDescription"] = "themed-event-balloon-description";
    IdStyles["ThemedEventTaskBackground"] = "themed-event-task-background";
    IdStyles["EventProgressBarBackground"] = "event-progress-bar-background";
    IdStyles["EventProgressBarFill"] = "event-progress-bar-fill";
    IdStyles["ThemedEventRewardBackground"] = "themed-event-reward-background";
    // Coop info view
    IdStyles["CoopInfoContainer"] = "coop-info-container";
    IdStyles["CoopInfoRankingContainer"] = "coop-info-ranking-container";
    IdStyles["CoopInfoGraphicContainer"] = "coop-info-graphic-container";
    IdStyles["CoopDateContainer"] = "coop-date-container";
    IdStyles["CoopDateContainerShine"] = "coop-date-container-shine";
    IdStyles["CoopInfoNameContainer"] = "coop-info-name-container";
    IdStyles["CoopInfoDescriptionContainer"] = "coop-info-description-container";
    IdStyles["CoopDateContainerBolt"] = "coop-date-container-bolt";
    IdStyles["CoopInfoStatContainer"] = "coop-info-stat-container";
    // Coop search view
    IdStyles["CoopListContainer"] = "coop-list-container";
    // Coop invite dialog
    IdStyles["CoopInvitationBackground"] = "Coop-invitation-background";
    IdStyles["CoopInvitationLevelBackground"] = "Coop-invitation-level-background";
    IdStyles["CoopInvitationTitleBackground"] = "Coop-invitation-title-background";
    IdStyles["CoopInvitationDescriptionBackground"] = "Coop-invitation-description-background";
    IdStyles["CoopInvitationNoticeBackground"] = "Coop-invitation-notice-background";
    // Coop found
    IdStyles["CoopFoundNameInput"] = "coop-found-name-input";
    IdStyles["CoopFoundGraphicsContainer"] = "coop-found-graphic-container";
    IdStyles["CoopFoundDescriptionInput"] = "coop-found-description-input";
    IdStyles["CoopFoundStatInput"] = "coop-found-stat-input";
    // Coop Message Board
    IdStyles["CoopNoticeContainer"] = "coop-notice-container";
    IdStyles["CoopNoticeInfoContainer"] = "coop-notice-info-container";
    IdStyles["CoopInfoDescriptionLargeContainer"] = "coop-info-description-large-container";
    IdStyles["TableRowCoopNotice"] = "table-row-coop-notice";
    // player profile
    IdStyles["PlayerProfileLeagueBackground"] = "Player-profile-league-background";
    IdStyles["PlayerProfileCoopBackground"] = "Player-profile-coop-background";
    IdStyles["PlayerProfileTextBackground"] = "Player-profile-name-background";
    // coop help
    IdStyles["CoopHelpInfoContainer"] = "coop-help-info-container";
    IdStyles["CoopHelpPointsReceivedContainer"] = "coop-help-points-received-container";
    IdStyles["CoopHelpPointsContainer"] = "coop-help-points-container";
    IdStyles["TableRowCoopHelp"] = "table-row-coop-help";
    // Coop Chat
    IdStyles["CoopChatMessageViewContainer"] = "coop-chat-container";
    IdStyles["CoopChatReceivedContainer"] = "coop-chat-received-container";
    IdStyles["CoopChatSentContainer"] = "coop-chat-sent-container";
    IdStyles["CoopChatInput"] = "coop-chat-input";
    // coop projects
    IdStyles["TableRowProjects"] = "table-row-projects";
    IdStyles["TableRowProjectsGold"] = "table-row-projects-gold";
    IdStyles["BlackOverlay"] = "black-overlay";
    IdStyles["CoopProjectsStarContainer"] = "projects-star-amount-container";
    IdStyles["CoopProjectsDetailsGraphic"] = "graphic-placeholder";
    // discount dialog
    IdStyles["DiscountAmountContainer"] = "discount-amount-container";
    IdStyles["DiscountDescriptionContainer"] = "discount-description-container";
    // hud happiness
    IdStyles["hudHappinessPositiveFill"] = "hud-happiness-positive-fill";
    IdStyles["hudHappinessNegativeFill"] = "hud-happiness-negative-fill";
    // Purchase points event
    IdStyles["TraderBadge"] = "trader-badge";
    IdStyles["TraderBubbleContainer"] = "trader-bubble-container";
    IdStyles["TraderEventTimerContainer"] = "trader-event--timer-container";
    IdStyles["PurchasePointsEventWoodFrame"] = "purchase-points-event-wood-frame";
    IdStyles["PurchasePointsEventContainer"] = "purchase-point-event-container";
    IdStyles["PurchasePointsPackageBackgroundContainer"] = "purchase-points-package-background-container";
    IdStyles["PurchasePointsItemBackgroundContainer"] = "purchase-points-item-background-container";
    IdStyles["PurchasePointsItemBackgroundContainerRequirement"] = "purchase-points-item-background-container-requirement";
    // Trader event
    IdStyles["TraderEventPackageBackgroundContainer"] = "trader-event-package-background-container";
    IdStyles["TraderEventItemBackgroundContainer"] = "trader-event-item-background-container";
    IdStyles["TraderEventRewardImageBackground"] = "trader-event-reward-image-background";
    IdStyles["TraderRewardContainer"] = "trader-reward-container";
    IdStyles["TraderRewardContainerWrapper"] = "trader-reward-container-wrapper";
    IdStyles["OfferBonusBlueBackground"] = "offer-bonus-blue-background";
    // Fortune Teller Event
    IdStyles["FortuneTellerRewardBackground"] = "fortune-teller-reward-background";
    IdStyles["GlassBallPlaceholder"] = "glas-ball-placeholder";
    // Balloon Offer
    IdStyles["BalloonOfferContainerRewards"] = "ballon-offer-container-rewards";
    IdStyles["BalloonOfferContainerDescription"] = "ballon-offer-container-description";
    IdStyles["BalloonTimerBackground"] = "expansion-timer-background";
    // Discount event timer
    IdStyles["ExpansionTimer"] = "expansion-timer";
})(IdStyles || (IdStyles = {}));



//////////////////
// WEBPACK FOOTER
// ./src/less/IdStyles.ts
// module id = 1
// module chunks = 3